"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFreemiumViralLink;

var _hubspotUrlinator = _interopRequireDefault(require("hubspot.urlinator.Url"));

var _SignupUrlGenerator = _interopRequireDefault(require("signup-ui-core/SignupUrlGenerator"));

var _SignupFlows = require("signup-ui-core/constants/SignupFlows");

var _AllowedHubs = _interopRequireDefault(require("signup-ui-core/constants/AllowedHubs"));

var _AllowedCustomOpts = _interopRequireDefault(require("signup-ui-core/constants/AllowedCustomOpts"));

var _AllowedIntents = _interopRequireDefault(require("signup-ui-core/constants/AllowedIntents"));

var _AllowedUtms = _interopRequireDefault(require("signup-ui-core/constants/AllowedUtms"));

function getFreemiumViralLink(viralPage) {
  var salesUrl = new _SignupUrlGenerator.default(_SignupFlows.SignupFlows.SALES).withHubs(_AllowedHubs.default.HUBS_CAMPAIGN, 'hubspot-meetings-virality').withHubs(_AllowedHubs.default.HUBS_CTA, viralPage).withUtm(_AllowedUtms.default.UTM_MEDIUM, 'virality').withOption(_AllowedCustomOpts.default.MEETING_SIDEBAR).withIntent(_AllowedIntents.default.MEETINGS).getUrl();
  return new _hubspotUrlinator.default(salesUrl, {
    lb: 'app'
  }).href;
}

module.exports = exports.default;